import { render, staticRenderFns } from "./TextAnswerItem.vue?vue&type=template&id=0c1c6efa&scoped=true&"
import script from "./TextAnswerItem.vue?vue&type=script&lang=js&"
export * from "./TextAnswerItem.vue?vue&type=script&lang=js&"
import style0 from "./TextAnswerItem.vue?vue&type=style&index=0&id=0c1c6efa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1c6efa",
  null
  
)

export default component.exports